import { MemoizedSelector, Store } from '@ngrx/store';
import { IDocumentStore } from './document-store.interface';
import { getTmpCache, IDocumentState } from './document-data.reducer';
import { EntityDataStore } from '../entity-data/entity-data.store';
import { Document } from './document.model';
import { Map } from 'immutable';
import { serialize } from '../../utils/helpers/model.helper';
import { distinctUntilChanged, map, withLatestFrom } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { has } from 'lodash';

// should only be used as a superclass; this class is not injectable
export class DocumentDataStore<T extends IDocumentState, U extends Document>
  extends EntityDataStore<T, U>
  implements IDocumentStore {
  constructor(store: Store<any>, selectFeature: MemoizedSelector<Object, T>) {
    super(store, selectFeature);
  }

  hasEditingEntityValueChanged(): Observable<boolean> {
    return this.getEditingEntity().pipe(
      withLatestFrom(this.getOriginalEditingEntity()),
      map(([editingEntity, originalEditingEntity]: U[]) => {
        if (!editingEntity || !originalEditingEntity) {
          return false;
        }

        const serializedEntity = this._removeUnnecessaryFields(editingEntity);
        const serializedOriginalEntity = this._removeUnnecessaryFields(
          originalEditingEntity
        );

        return !serializedEntity.equals(serializedOriginalEntity);
      }),
      distinctUntilChanged()
    );
  }

  getInTmpCache<V>(key: string): Observable<V> {
    return this.store
      .select(getTmpCache(this.selectFeature))
      .pipe(map((cache) => (has(cache, key) ? (cache[key] as V) : null)));
  }

  private _removeUnnecessaryFields(entity: Map<string, any>) {
    return serialize(entity || Map({})).withMutations((document) =>
      document
        .remove(Document.KEYS.PAYMENTS)
        .remove(Document.KEYS.METADATA)
        .remove(Document.KEYS.LATEST_CALCULATION_RESULTS)
        .remove(Document.KEYS.LATEST_ACTIVITY)
        .remove(Document.KEYS.LINKS)
    );
  }
}
